import { useLocalStorageState } from 'ahooks';
import { useEffect } from 'react';
export const useToggleFreeMode = ({ active, localStorageKey, onToggle })=>{
    const [, saveToLocalStorage] = useLocalStorageState(localStorageKey);
    useEffect(()=>{
        saveToLocalStorage(active);
    }, [
        active,
        saveToLocalStorage
    ]);
    const exit = ()=>{
        onToggle(false);
    };
    const enter = ()=>{
        onToggle(true);
    };
    return {
        active,
        exit,
        enter
    };
};
